import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from 'styled-components';
import 'antd/dist/antd.css';
import { NavLink } from "react-router-dom";
import { Layout, Menu } from 'antd';
import { DashboardOutlined, FileTextOutlined } from '@ant-design/icons';
import { BiStation } from "react-icons/bi";
import { FaUsersCog, FaUserShield, FaMapMarkedAlt,FaRegBuilding } from "react-icons/fa";
import { GoGraph } from "react-icons/go";

import Service from '../../service/_Master'

const { SubMenu } = Menu;

const Sidebar = styled.div`

    @media only screen and (max-width:1200px){
        display: none;
    }

    @media only screen and (min-width:1200px){
        left: 0px;
        z-index: 9999;
        float: left !important;

        .ant-menu{
            height: 100%;
        }

        .ant-layout-sider{
            height: 100%;
        }
    }
    
`;

const NavBarLink = styled(NavLink)`
  text-decoration: none;
  color: #000;
  padding: 6px 0px;

  &:hover {
    text-decoration: none;
    border-bottom: 1.5px solid #007bff;
  }
`;

const { Sider } = Layout;

export default function Index(props) {

    const path = useSelector(state => state.master.path)
    const [menu, setMenu] = useState([])
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        const init = async () => {
          let menus = await Service.getMenus()
          setMenu(menus);
        };
    
        init()
      }, []);

      const menuIcon = (path) => {
        if (path == '/dashboard') return <DashboardOutlined />
        if (path == '/map') return <FaMapMarkedAlt />
        if (path == '/stations') return <FileTextOutlined />
        if (path == '/compare-graph') return <GoGraph />
        if (path == '/mgt-station') return <FaRegBuilding />
        if (path == '/mgt-sensor') return <BiStation />
        if (path == '/mgt-user') return <FaUsersCog />
        if (path == '/mgt-permission') return <FaUserShield />
      }
    
      const fetchSubMenu = (list, parentsPath) => {
        return list.map((subMenu, index) => {
          let path = parentsPath === "/" ? subMenu.path : parentsPath + subMenu.path;
          return (
            <Menu.Item key={path} onClick={props.fncToggleNavBar}>
              <NavBarLink to={path}>{subMenu.disp_name}</NavBarLink>
            </Menu.Item>
          );
        });
      };
    
      const fetchMenu = menu.map((menu, index) => {
        return menu.sub.length > 0 ? (
          <SubMenu key={menu.path} title={<span>{menu.disp_name}</span>}>
            {fetchSubMenu(menu.sub, menu.path)}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.path} onClick={props.fncToggleNavBar} icon={menuIcon(menu.path)}>
            <NavBarLink to={menu.path}>{menu.disp_name}</NavBarLink>
          </Menu.Item>
        );
      });
      
      

    const onCollapse = async () => {
        setCollapsed(true)
    }

    return (
        <Sidebar>
            <Sider className="sidebar" collapsible onCollapse={onCollapse}>
                <div className="logo" />
                <Menu theme="dark" defaultSelectedKeys={[`${path}`]} selectedKeys={[`${path}`]} mode="inline" >
                    {fetchMenu}
                </Menu>
            </Sider>
        </Sidebar >
    )


}